import React from "react";

const ResumePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 p-6 md:p-12 font-sans">
      
      {/* Header */}
      <header className="text-center mb-8">
        <h1 className="text-4xl font-bold mb-2">
          Chimwemwe Andrew Chinamale
        </h1>
        <p className="text-lg">
          Phone: +265884107063 | Email: cchinamale@gmail.com | Work Email:
          cchinamale@pedaids.org
        </p>
        <p className="text-md mt-1">
          Lilongwe, Malawi
        </p>
      </header>

      {/* Summary */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Professional Summary</h2>
        <p>
          Digital Health and DHIS2 specialist with over five years of experience
          designing, implementing, and optimizing health information systems,
          analytics platforms, and geospatial solutions supporting Ministries of
          Health and international development partners. Experienced in DHIS2
          configuration (aggregate and tracker), health data interoperability,
          PostgreSQL/PostGIS database architecture, Power BI analytics, and
          cloud-based system deployment. Proven ability to translate complex
          programmatic workflows into scalable digital solutions while improving
          data quality, reporting efficiency, and decision-making across national
          and subnational health systems.
        </p>
      </section>

      {/* Experience */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Professional Experience</h2>

        {/* EGPAF */}
        <div className="mb-6">
          <h3 className="text-xl font-bold">
            Data Scientist / Informatics (Geospatial) Officer
          </h3>
          <p className="italic">
            The Elizabeth Glaser Pediatric AIDS Foundation (EGPAF) | Feb 2020 –
            Present
          </p>

          <ul className="list-disc list-inside mt-2">
            <li>
              Developed and maintained Power BI dashboards supporting national
              HIV care and treatment monitoring and program performance analysis.
            </li>
            <li>
              Designed and implemented DHIS2 aggregate and tracker tools aligned
              with Ministry of Health reporting workflows.
            </li>
            <li>
              Administered DHIS2 PostgreSQL databases including optimization,
              backup strategies, and performance tuning.
            </li>
            <li>
              Developed geospatial analytics platforms integrating DHIS2 APIs,
              EMR systems, and spatial datasets for program monitoring.
            </li>
            <li>
              Designed and deployed geospatial databases using PostgreSQL/PostGIS
              supporting multi-level health system analysis.
            </li>
            <li>
              Built automated data pipelines and APIs enabling interoperability
              between health information systems and analytics platforms.
            </li>
            <li>
              Supported CRVS, EMR, and care & treatment digital health
              interventions through software and analytics development.
            </li>
            <li>
              Applied machine learning techniques for anomaly detection, disease
              trend analysis, and predictive analytics using routine health data.
            </li>
            <li>
              Provisioned cloud infrastructure (AWS VPC, EC2, RDS) using
              Terraform and containerized deployments.
            </li>
            <li>
              Developed conversational AI solutions to improve access to health
              information services.
            </li>
          </ul>

          <p className="mt-1 font-semibold">Technologies:</p>
          <p>
            DHIS2, Power BI, PostgreSQL/PostGIS, Python, JavaScript, React,
            Leaflet, Docker, AWS, Terraform, QGIS, ArcGIS, Redis, GDAL,
            GeoServer, OpenAI API
          </p>
        </div>

                {/* DHIS2 Co-Consultant */}
        <div className="mb-6">
          <h3 className="text-xl font-bold">
            DHIS2 Co-Consultant (Power BI & Analytics Optimization)
          </h3>
          <p className="italic">
            Malawi Analytics Platform (MAP) | Jan 2026 – Mar 2026
          </p>

          <ul className="list-disc list-inside mt-2">
            <li>
              Conducted structured technical and functional assessments of existing
              Power BI dashboards and underlying DHIS2 datasets to identify
              performance gaps and enhancement opportunities.
            </li>
            <li>
              Redesigned Quality Improvement (QI) reporting dashboards using
              user-centred design principles to improve usability, navigation,
              and data interpretation for national and subnational stakeholders.
            </li>
            <li>
              Implemented hierarchical drill-down and drill-through functionality
              across national, zonal, district, and facility administrative levels.
            </li>
            <li>
              Configured Role-Level Security (RLS) to enforce controlled data
              access aligned with user roles and administrative permissions.
            </li>
            <li>
              Optimized DHIS2 API queries enabling automated and scheduled data
              refresh processes with improved performance and reliability.
            </li>
            <li>
              Implemented refresh monitoring, automated failure notifications,
              and data quality validation mechanisms.
            </li>
            <li>
              Coordinated system integration testing and User Acceptance Testing
              (UAT) with national, district, and facility stakeholders.
            </li>
            <li>
              Delivered training sessions and technical knowledge transfer on
              dashboard administration, maintenance, and troubleshooting.
            </li>
            <li>
              Developed administrator documentation supporting long-term system
              sustainability and ownership.
            </li>
            <li>
              Supported deployment through Power BI workspace integration and
              provided post-launch technical support and performance monitoring.
            </li>
          </ul>

          <p className="mt-1 font-semibold">Technologies:</p>
          <p>
            DHIS2 API, Power BI, DAX, PostgreSQL, Data Modeling, Role-Level
            Security (RLS), Microsoft Power BI Service
          </p>
        </div>

        {/* Palladium */}
        <div className="mb-6">
          <h3 className="text-xl font-bold">
            GIS / Database & Digital Health Solutions Consultant
          </h3>
          <p className="italic">
            Palladium – Propel Health | Sep 2024 – Dec 2024
          </p>

          <ul className="list-disc list-inside mt-2">
            <li>
              Translated complex Excel-based program trackers into normalized
              PostgreSQL database schemas for Family Planning and Youth Friendly
              Health Services programmes.
            </li>
            <li>
              Designed and developed a centralized project database and backend
              APIs supporting analytics and external integrations.
            </li>
            <li>
              Performed large-scale data cleaning, migration, and structured data
              import workflows.
            </li>
            <li>
              Developed system backend services and frontend access portals,
              including GIS-enabled web applications.
            </li>
            <li>
              Built comprehensive geospatial hierarchy structures enabling
              performance tracking from facility to national levels.
            </li>
            <li>
              Implemented role-based access control and strict validation rules
              to improve data quality and eliminate spreadsheet-based reporting
              errors.
            </li>
            <li>
              Developed Power BI and Tableau dashboards in collaboration with
              Malawi Ministry of Health Digital Health Division.
            </li>
            <li>
              Optimized spatial queries and database performance for large
              datasets.
            </li>
            <li>
              Developed SOPs, conducted trainings, and supported system
              deployment through automated cloud pipelines.
            </li>
          </ul>

          <p className="mt-1 font-semibold">Technologies:</p>
          <p>
            PostgreSQL/PostGIS, React, Flask, Docker, Nginx, Tailwind,
            Celery, Redis, GitHub Actions, Power BI, Tableau
          </p>
        </div>

        {/* Freelance */}
        <div>
          <h3 className="text-xl font-bold">
            Freelance GIS, Machine Learning & Software Engineer
          </h3>
          <p className="italic">Remote | Apr 2020 – Present</p>

          <ul className="list-disc list-inside mt-2">
            <li>
              Developed machine learning and computer vision systems for
              geospatial and industrial analytics applications.
            </li>
            <li>
              Built and optimized ML models for prediction, regression, and edge
              deployment scenarios.
            </li>
            <li>
              Processed and analyzed hyperspectral and spatial datasets using
              advanced geospatial pipelines.
            </li>
            <li>
              Managed data labeling workflows and model training pipelines.
            </li>
          </ul>

          <p className="mt-1 font-semibold">Technologies:</p>
          <p>
            Python, TensorFlow, PyTorch, OpenCV, GDAL, NumPy, Pandas,
            QGIS, ArcGIS, Docker, ROS
          </p>
        </div>
      </section>

      {/* Education */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Education</h2>
        <ul className="list-disc list-inside">
          <li>
            BSc Physical Planning (GIS) — University of Malawi | 2014 – 2020
          </li>
          <li>
            RPAT Certificate (Virginia Tech) — African Drone & Data Academy
            (UNICEF) | 2020
          </li>
        </ul>
      </section>

      {/* Skills */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Core Skills</h2>
        <p>
          DHIS2 Configuration & Administration, Digital Health Systems,
          Health Data Interoperability, Database Architecture, Geospatial
          Analytics, Power BI & Data Visualization, API Development,
          Cloud Deployment, Technical Training & Mentorship
        </p>
      </section>

      {/* Tools */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Tools & Technologies</h2>
        <p>
          <strong>Databases:</strong> PostgreSQL/PostGIS, MySQL <br />
          <strong>Programming:</strong> Python, JavaScript, React, Flask, Go <br />
          <strong>Analytics:</strong> Power BI, Tableau <br />
          <strong>DevOps:</strong> Docker, Terraform, GitHub Actions,
          Kubernetes <br />
          <strong>GIS:</strong> QGIS, ArcGIS, GeoServer, GDAL
        </p>
      </section>

      {/* Certificates */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Certifications</h2>
        <ul className="list-disc list-inside">
          <li>Do-It-Yourself Geo Apps (ESRI MOOC)</li>
          <li>AWS Certified Cloud Practitioner</li>
          <li>AWS Certified Solutions Architect</li>
        </ul>
      </section>

            {/* Publications */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Publications</h2>

        <ul className="list-disc list-inside">
          <li>
            Chinamale, C.A. (2026). <span className="italic">
            Integrated Data Analytics Systems to Improve Quality Data Outcomes:
            Case Scenario from the Malawi Analytics Platform (MAP)
            </span>. Journal of Health Informatics in Africa (JHIA).
            <br />
            <a
              href="https://www.researchgate.net/publication/394448246_Submission_to_the_JHIA_Author_information_page_Integrated_data_analytics_systems_to_improve_quality_data_outcomes_Case_scenario_from_the_Malawi_Analytics_Platform_MAP_A_Case_Scenario_in_Malawi/references"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              View publication
            </a>
          </li>
        </ul>
      </section>

    </div>
  );
};

export default ResumePage;